import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'white',
    // border: '',
    boxShadow: 24,
    p: 4,
};

export default function Modals({ children, isOpen, onClose, title, }) {

    return (
        <div>
            
            <Modal
                open={isOpen}
                onClose={onClose}
                
            >
                <Box sx={style}>
                   
                    <>
                        {children}
                    </>
                </Box>
            </Modal>
        </div>
    );
}